<div class="mb-5">
    <button
      class="btn btn-primary-dark btn-sm text-xxs shadow mt-3 mb-2"
      data-bs-toggle="modal" data-bs-target="#create_new_rule_set"
    >
      + New Rule Set
    </button>

    <!-- Table for rule sets -->
    <div class="card shadow rounded-lg border table-border-color p-4 table-responsive">
      <table id="group_compliance_rules_table"  :key="'table_' + active_tab" class="table table-hover">
        <thead class="custom-header">
          <tr>
            <th v-for="header in table_headers" :key="header" class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rule_set in table_data" :key="rule_set.id">
            <td class="text-xxs text-start">{{ rule_set['Rule Set Name'] }}</td>
            <td class="text-xxs text-start">{{ rule_set.Description }}</td>
            <td class="text-xxs text-start">{{ rule_set['Rules Count'] }}</td>
            <td class="text-xxs text-start">
              <span class="status-badge" :class="rule_set.Status.toLowerCase()">
                {{ rule_set.Status }}
              </span>
            </td>
            <td class="text-xxs text-start">
              <button class="btn btn-sm btn-primary-dark text-xxs me-2" data-bs-toggle="modal" data-bs-target="#edit_new_rule_set" @click="open_edit_modal(rule_set.id)">Edit</button>
              <button class="btn btn-sm btn-primary-dark text-xxs me-2">Delete</button>
              <button class="btn btn-sm btn-primary-dark text-xxs me-2" data-bs-toggle="modal" data-bs-target="#assign_rules_to_ruleset"
                @click="open_assign_modal(rule_set.id)">
              Assign Rules
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</div>

<!-- Modal for creating new compliance rule set -->
<teleport to="body">
  <div class="modal fade" id="create_new_rule_set" tabindex="-1" aria-labelledby="create_new_rule_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <h5 class="modal-title text-white text-xxs" id="create_new_rule_label">Create New Compliance Rule Set</h5>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="create_rule_set">
              <!-- Rule Set Name -->
              <div class="mb-3">
                <label for="rule_set_name" class="modal-form-label form-label fw-bold text-xxs">
                  Rule Set Name <span class="text-danger">*</span>
                </label>
                <input 
                  type="text" 
                  class="modal-form-control form-control text-xxs" 
                  id="rule_set_name" 
                  v-model="new_ruleset_name"
                  placeholder="Enter rule set name" 
                  required
                >
              </div>
              
              <!-- Rule Set Description -->
              <div class="mb-3">
                <label for="rule_set_description" class="modal-form-label form-label fw-bold text-xxs">
                  Description
                </label>
                <textarea
                  class="modal-form-control form-control text-xxs" 
                  id="rule_set_description" 
                  v-model="new_ruleset_description"
                  placeholder="Enter description (optional)" 
                  rows="2"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary-dark text-xxs" @click="create_rule_set">
              Create Rule Set
            </button>
          </div>
        </div>
      </div>
  </div>
</teleport>
<!-- Edit Modal -->
<teleport to="body">
<div class="modal fade" id="edit_new_rule_set" tabindex="-1" aria-labelledby="edit_new_rule_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs" id="create_new_rule_label">Edit Compliance Rule Set</h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="update_rule_set">
            <!-- Rule Set Name -->
            <div class="mb-3">
              <label for="edit_rule_set_name" class="modal-form-label form-label fw-bold text-xxs">
                Rule Set Name <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="modal-form-control form-control text-xxs"
                id="edit_rule_set_name"
                v-model="editing_ruleset.name"
                placeholder="Enter rule set name"
                required
              >
            </div>

            <!-- Rule Set Description -->
            <div class="mb-3">
              <label for="edit_rule_set_description" class="modal-form-label form-label fw-bold text-xxs">
                Description
              </label>
              <textarea
                class="modal-form-control form-control text-xxs"
                id="edit_rule_set_description"
                v-model="editing_ruleset.description"
                placeholder="Enter description (optional)"
                rows="2"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary-dark text-xxs" @click="update_rule_set">
            Save
          </button>
        </div>
      </div>
    </div>
</div>
</teleport>
<!-- Modal for assigning rules -->
<teleport to="body">
<div class="modal fade" id="assign_rules_to_ruleset" tabindex="-1" aria-labelledby="assign_rules_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg"> <!-- Increased size -->
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs" id="assign_rules_label">Assign Rules to Rule Set : {{ editing_ruleset.name }}</h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table id="assign_rules_table" class="table table-hover">
              <thead class="custom-header">
                <tr>
                  <th class="text-xxs text-uppercase font-weight-bolder opacity-7">Rule Name</th>
                  <th class="text-xxs text-uppercase font-weight-bolder opacity-7">Description</th>
                  <th class="text-xxs text-uppercase font-weight-bolder opacity-7">Status</th>
                  <th class="text-xxs text-uppercase font-weight-bolder opacity-7">Assign</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="rule in compliance_rules" :key="rule.id">
                  <td class="text-xxs">{{ rule.name }}</td>
                  <td class="text-xxs">{{ rule.description }}</td>
                  <td class="text-xxs">
                    <span class="status-badge" :class="rule.is_active ? 'active' : 'inactive'">
                      {{ rule.is_active ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td class="text-xxs">
                    <div class="form-check form-switch">
                     <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      :id="'toggle_' + rule.id"
                      :checked="is_rule_assigned(rule.id)"
                      @change="toggle_rule_assignment(rule.id, $event.target.checked)"
                     >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary-dark text-xxs" data-bs-dismiss="modal">
            Done
          </button>
        </div>
      </div>
    </div>
</div>
</teleport>
  